import React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

function createData(id, rate, rateUpdate, oldRvRate, newRvRate, reason) {
  return { id, rate, rateUpdate, oldRvRate, newRvRate, reason };
}

const rows = [
  createData("1", "19-02-2023", "19-02-2023", "$0.00", "$0.00", "90 Day Eval"),
  createData("2", "19-02-2023", "19-02-2023", "$0.00", "$0.00", "90 Day Eval"),
  createData("3", "19-02-2023", "19-02-2023", "$0.00", "$0.00", "90 Day Eval"),
];

function RateHistoryTable() {
  return (
    <div>
      <TableContainer component={Paper} className="tableContainer">
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead sx={{ bgcolor: "#FAFAFB" }}>
            <TableRow>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] ratesTableHead"
              >
                #
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] ratesTableHead"
              >
                New rate effective date
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] ratesTableHead"
              >
                Last pay rate update
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] ratesTableHead"
              >
                Old RV Rate
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] ratesTableHead"
              >
                New RV Rate
              </TableCell>
              <TableCell
                align="left"
                className="!font-bold !text-[#98A2B3] text-[12px] ratesTableHead"
              >
                Reason
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row) => (
              <TableRow
                key={row.id}
                sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
              >
                <TableCell align="left" className="ratesTableBody">
                  {row.id}
                </TableCell>
                <TableCell align="left" className="ratesTableBody">
                  {row.rate}
                </TableCell>
                <TableCell align="left" className="ratesTableBody">
                  {row.rateUpdate}
                </TableCell>
                <TableCell align="left" className="ratesTableBody">
                  {row.oldRvRate}
                </TableCell>
                <TableCell align="left" className="ratesTableBody">
                  {row.newRvRate}
                </TableCell>
                <TableCell align="left" className="ratesTableBody">
                  {row.reason}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  );
}

export default RateHistoryTable;
